<template>
  <div>
    <div v-for="build in buildings" :key="build._id">
      
      <div v-if="build.floor.length > 0">
          <b-card :title="site_name+' - '+build.name+' - '+l" class="mb-2" v-for="(l,i) in build.floor" :key="i+''+build._id">
              <b-row>
                
                  <b-col md="6" v-for="(location, index) in locations">
                      <OverViewTable2 :location="location._id" :title="location.name" :level="l" :building="build" />
                  </b-col>

                  <!-- <b-col md="6">
                      <OverViewTable2 title="Female" :level="l" :building="build" />
                  </b-col> -->
              </b-row>
          </b-card>
      </div>

    </div>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination,VBTooltip
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import { POST_API_SUCCESS,POST_API } from "../../../store/actions.type"
import OverViewTable2 from './OverviewTable2';

export default {
  props: ['site', 'site_name'],
  components: {
    OverViewTable2,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    VBTooltip,
    vSelect,
  },
  directives: {
    'b-tooltip': VBTooltip,
    
  },
  data() {
    return {
      buildings: [],
      building:null,
      levels: [],
      level:'',
      locations : null,
    }
  },
  methods : {
    getBuilding(){
            
            this.buildings = [];
            this.building = null;
            this.levels = [];
            this.level = '';

            return this.$store.dispatch(POST_API_SUCCESS, {
                data:{
                    role:this.$store.getters.currentUser.role,
                    site:this.site
                },
                // api: '/api/all-buildings'
                api: '/api/all-buildings-with-level'
            })
            .then(() => {
                if (this.$store.getters.containsErrors) {
                    this.error_message = this.$store.getters.getErrors;
                } else {
                    this.buildings    = this.$store.getters.getResults.data;
                    return this.buildings;
                }
            });
        },

        getLevels(){
            this.levels = [];
            this.level = '';

            this.levels = this.building.floor;

            return this.levels;
        },
        allLocations(){
            return this.$store.dispatch(POST_API, {
                data:{},
                api: '/api/all-database-location-2'
            })
            .then(() => {
                if (this.$store.getters.containsErrors) {
                    this.error_message = this.$store.getters.getErrors;
                    this.showDismissibleAlert = true;
                    window.scrollTo(0,0);
                } else {
                    this.locations = this.$store.getters.getResults.data;
                    return this.locations;
                }
            });
        },
    
  }, 
  mounted(){
    this.getBuilding();
    this.allLocations();
  }
  
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>